<ng-container thr-parent-form>
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-auto mb-4 mb-sm-0 mr-sm-4">
                <mat-slide-toggle name="pmpIsSpanish" color="blue-gray" labelPosition="before" [disabled]="client.disabled" [(ngModel)]="client.isSpanish">
                    {{ 'form.you-are-spanish' | translate }}
                </mat-slide-toggle>
            </div>
            <div class="col-12 col-sm-auto">
                <mat-slide-toggle name="pmpIsResident" color="blue-gray" labelPosition="before" [disabled]="client.disabled" [(ngModel)]="client.isResident">
                    {{ 'form.you-are-resident' | translate }}
                </mat-slide-toggle>
            </div>
        </div>

        <hr class="mt-4 mb-3" />

        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select name="pmpDocumentType" [placeholder]="'form.document' | translate" [disabled]="client.disabled" [(ngModel)]="client.docType">
                        <ng-template ngFor let-type [ngForOf]="client.allowedDocTypes">
                            <mat-option [value]="type">{{ 'form.document-types.' + type | translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <ng-container [ngSwitch]="client.docType">
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.DNI">
                        <mat-label>{{ 'form.document-types.DN' | translate }}</mat-label>
                        <input name="pmpDocument" matInput [placeholder]="'form.hints.dni' | translate" required minlength="9" maxlength="10" dni [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.DNI" existsInContract [clientId]="client.id" [field]="'docId'"
                            [otherValue]="currentTutor ? currentTutor.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" #documentCtrl="ngModel" />
                        <mat-error *ngIf="documentCtrl.hasError('dni') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIF">
                        <mat-label>{{ 'form.document-types.NF' | translate }}</mat-label>
                        <input name="pmpDocument" matInput [placeholder]="'form.hints.nif' | translate" required minlength="9" maxlength="15" nif [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.NIF" existsInContract [clientId]="client.id" [field]="'docId'"
                            [otherValue]="currentTutor ? currentTutor.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" #documentCtrl="ngModel" />
                        <mat-error *ngIf="documentCtrl.hasError('nif') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE">
                        <mat-label>{{ 'form.document-types.NR' | translate }}</mat-label>
                        <input name="pmpDocument" matInput [placeholder]="'form.hints.nie' | translate" required minlength="9" maxlength="15" nie [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.NIE" existsInContract [clientId]="client.id" [field]="'docId'"
                            [otherValue]="currentTutor ? currentTutor.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" #documentCtrl="ngModel" />
                        <mat-error *ngIf="documentCtrl.hasError('nie') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE_NOT_RESIDENT">
                        <mat-label>{{ 'form.document-types.NN' | translate }}</mat-label>
                        <input name="pmpDocument" matInput [placeholder]="'form.hints.nie' | translate" required maxlength="15" nie [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.NIE_NOT_RESIDENT" existsInContract [clientId]="client.id" [field]="'docId'"
                            [otherValue]="currentTutor ? currentTutor.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel" />
                        <mat-error *ngIf="documentCtrl.hasError('nie') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT">
                        <input name="pmpDocument" matInput [placeholder]="'form.document-types.PN' | translate" required maxlength="15" [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.PASSPORT" existsInContract [clientId]="client.id" [field]="'docId'" [otherValue]="currentTutor ? currentTutor.docId : null"
                            [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel" />
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT_LATIN">
                        <input name="pmpDocument" matInput [placeholder]="'form.document-types.PL' | translate" required maxlength="15" [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.PASSPORT_LATIN" existsInContract [clientId]="client.id" [field]="'docId'"
                            [otherValue]="currentTutor ? currentTutor.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel" />
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PERMISSION">
                        <input name="pmpDocument" matInput [placeholder]="'form.document-types.PR' | translate" required maxlength="15" [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.PERMISSION" existsInContract [clientId]="client.id" [field]="'docId'" [otherValue]="currentTutor ? currentTutor.docId : null"
                            [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel" />
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchDefault>
                        <input name="pmpDocument" matInput [placeholder]="'form.document-types.TR' | translate" required maxlength="15" [clientExists]="!isClientPortal && isFirst" [docType]="DocumentType.IDENTIFICATION_CARD_NOT_RESIDENT" existsInContract [clientId]="client.id"
                            [field]="'docId'" [otherValue]="currentTutor ? currentTutor.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel" />
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                        ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <!-- TODO: BUG with required dynamic in child form component https://github.com/angular/angular/issues/23657 -->
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="!client.docExpirationDatePermanent">
                    <mat-label>{{ 'form.expired-document-date.' + client.docType | translate }}</mat-label>
                    <input name="pmpDocumentExpiration" matInput [min]="today" [matDatepicker]="documentPicker" required maxlength="10" [disabled]="client.disabled" [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.docExpirationDate" #documentExpirationCtrl="ngModel"
                    />
                    <mat-datepicker-toggle matSuffix [for]="documentPicker"></mat-datepicker-toggle>
                    <mat-datepicker #documentPicker [disabled]="client.disabled"></mat-datepicker>
                    <mat-error *ngIf="!documentExpirationCtrl.valid">
                        {{ 'form.validation.expired-document-date' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="client.docExpirationDatePermanent">
                    <mat-label>{{ 'form.expired-document-date.' + client.docType | translate }}</mat-label>
                    <input name="pmpDocumentExpiration" matInput [min]="today" [matDatepicker]="documentPicker" disabled [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.docExpirationDate" #documentExpirationCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="documentPicker"></mat-datepicker-toggle>
                    <mat-datepicker #documentPicker disabled></mat-datepicker>
                    <mat-error *ngIf="!documentExpirationCtrl.valid">
                        {{ 'form.validation.expired-document-date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-2 mb-3 mb-sm-0 mt-sm-2 mt-md-3">
                <mat-checkbox name="pmpPermanentValidity" [disabled]="client.type === ClientType.MINOR || client.disabled" [(ngModel)]="client.docExpirationDatePermanent">
                    {{ 'form.permanent-validity' | translate }}
                </mat-checkbox>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input name="pmpName" matInput [placeholder]="'form.name' | translate" required maxlength="20" [disabled]="client.disabled" [(ngModel)]="client.name" #nameCtrl="ngModel" />
                    <mat-error *ngIf="nameCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input name="pmpSurname" matInput [placeholder]="'form.surname' | translate" required maxlength="60" [disabled]="client.disabled" [(ngModel)]="client.surname" #surnameCtrl="ngModel" />
                    <mat-error *ngIf="surnameCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select name="pmpGenderType" [placeholder]="'form.gender' | translate" [disabled]="client.disabled" [(ngModel)]="client.gender" required
                    #genderCtrl="ngModel">
                        <ng-template ngFor let-type [ngForOf]="client.allowedGenderTypes">
                            <mat-option [value]="type">{{ 'form.gender-types.' + type | translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                    <mat-error *ngIf="genderCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select name="pnpMaritalStatusType" [placeholder]="'form.marital-status' | translate" [disabled]="client.disabled" [(ngModel)]="client.maritalStatus" required
                    #maritalStatusCtrl="ngModel">
                        <ng-template ngFor let-type [ngForOf]="client.allowedMaritalStatusTypes">
                            <mat-option [value]="type">{{ 'form.marital-status-types.' + type | translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                    <mat-error *ngIf="maritalStatusCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4" *ngIf="!client.disabled">
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="client.type === ClientType.MINOR">
                    <mat-label>{{ 'form.birth-date' | translate }}</mat-label>
                    <input name="pmpBirthDate" matInput [max]="today" [min]="hundredYears" [matDatepicker]="birthDatePicker" required maxlength="10" ofMinorAge [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.birthDate" #birthDateCtrl="ngModel" [disabled]="client.disabled"
                    />
                    <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker [disabled]="client.disabled"></mat-datepicker>
                    <mat-error *ngIf="birthDateCtrl.hasError('ofMinorAge')">
                        {{ 'form.validation.of-minor-age' | translate }}
                    </mat-error>
                    <mat-error *ngIf="!birthDateCtrl.hasError('ofMinorAge') && !birthDateCtrl.valid">
                        {{ 'form.validation.invalid.date' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="client.type !== ClientType.MINOR">
                    <mat-label>{{ 'form.birth-date' | translate }}</mat-label>
                    <input name="pmpBirthDate" matInput [max]="today" [min]="hundredYears" [matDatepicker]="birthDatePicker" required maxlength="10" [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.birthDate" #birthDateCtrl="ngModel" [disabled]="client.disabled"
                    />
                    <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker [disabled]="client.disabled"></mat-datepicker>
                    <mat-error *ngIf="!birthDateCtrl.valid">
                        {{ 'form.validation.invalid.date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="client.type !== ClientType.MINOR">
            <div class="col-12 col-md-6">
                <mat-checkbox name="pmpNotPhone" [(ngModel)]="client.phoneExonerate" (ngModelChange)="onExonerate()" *ngIf="!client.disabled; else elsePhone">
                    {{ 'form.not-phone' | translate }}
                </mat-checkbox>
                <ng-template #elsePhone>
                    <mat-checkbox name="pmpNotPhone" [disabled]="true">
                        {{ 'form.not-phone' | translate }}
                    </mat-checkbox>
                </ng-template>
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pmpPhone" matInput [placeholder]="'form.phone' | translate" required minlength="9" pattern="[\d\+]+" existsInContract [clientId]="client.id" [field]="'phone'" [otherValue]="currentTutor ? currentTutor.phone : null" [phoneExists]="!isClientPortal"
                                [disabled]="client.phoneExonerate || client.disabled" [(ngModel)]="client.phone" #phoneCtrl="ngModel" />
                            <mat-error *ngIf="
                                    (phoneCtrl.hasError('minlength') || phoneCtrl.hasError('pattern')) && !phoneCtrl.hasError('required')
                            ">
                                {{ 'form.validation.invalid.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('phoneExists') && !phoneCtrl.hasError('required')">
                                {{ 'form.validation.phone-exists' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('existsInContract')">
                                {{ 'form.validation.phone-exists-in-contract' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pmpPhoneConfirm" matInput [placeholder]="'form.phone-confirm' | translate" required minlength="9" pattern="[\d\+]+" [equalTo]="phoneCtrl" [disabled]="client.phoneExonerate || client.disabled" [(ngModel)]="client.phoneConfirm" #phoneConfirmCtrl="ngModel"
                            />
                            <mat-error *ngIf="
                                    (phoneConfirmCtrl.hasError('minlength') || phoneConfirmCtrl.hasError('pattern')) &&
                                    !phoneConfirmCtrl.hasError('required')
                            ">
                                {{ 'form.validation.invalid.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                    phoneConfirmCtrl.hasError('equalTo') &&
                                    !phoneConfirmCtrl.hasError('minlength') &&
                                    !phoneConfirmCtrl.hasError('pattern') &&
                                    !phoneConfirmCtrl.hasError('required')
                            ">
                                {{ 'form.validation.equalTo.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneConfirmCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <mat-checkbox name="pmpNotEmail" [(ngModel)]="client.emailExonerate" (ngModelChange)="onExonerate()" *ngIf="!client.disabled; else elseEmail">
                    {{ 'form.not-email' | translate }}
                </mat-checkbox>
                <ng-template #elseEmail>
                    <mat-checkbox name="pmpNotEmail" [disabled]="true">
                        {{ 'form.not-email' | translate }}
                    </mat-checkbox>
                </ng-template>
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pmpEmail" matInput [placeholder]="'form.email' | translate" required emailWithDot existsInContract [clientId]="client.id" [field]="'email'" [otherValue]="currentTutor ? currentTutor.email : null" [emailExists]="!isClientPortal" [disabled]="client.emailExonerate || client.disabled"
                                [(ngModel)]="client.email" #emailCtrl="ngModel" />
                            <mat-error *ngIf="emailCtrl.hasError('email') && !emailCtrl.hasError('required')">
                                {{ 'form.validation.invalid.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('emailExists') && !emailCtrl.hasError('required')">
                                {{ 'form.validation.email-exists' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('existsInContract')">
                                {{ 'form.validation.email-exists-in-contract' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pmpEmailConfirm" matInput [placeholder]="'form.email-confirm' | translate" required emailWithDot [equalTo]="emailCtrl" [disabled]="client.emailExonerate || client.disabled" [(ngModel)]="client.emailConfirm" #emailConfirmCtrl="ngModel" />
                            <mat-error *ngIf="emailConfirmCtrl.hasError('email') && !emailConfirmCtrl.hasError('required')">
                                {{ 'form.validation.invalid.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                    emailConfirmCtrl.hasError('equalTo') &&
                                    !emailConfirmCtrl.hasError('email') &&
                                    !emailConfirmCtrl.hasError('required')
                            ">
                                {{ 'form.validation.equalTo.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailConfirmCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="fdonpLandLine" matInput [placeholder]="'form.telephone' | translate" minlength="9" pattern="[\d\+]+" [disabled]="isDisabled" [(ngModel)]="client.landLine" #landLineCtrl="ngModel" />
                            <mat-error *ngIf="(landLineCtrl.hasError('minlength') || landLineCtrl.hasError('pattern')) && !landLineCtrl.hasError('required')">
                                {{ 'form.validation.invalid.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="landLineCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>
            </div>
        </div>

        <div class="row" *ngIf="client.type !== ClientType.MINOR">
            <div class="col-12 mb-2 mb-sm-3">
                <mat-checkbox name="pmpLegal" required [disabled]="client.disabled" [(ngModel)]="client.acceptLegal">
                    <span>
                        {{ 'form.accept-legal' | translate }}
                        <a href="javascript:void(0)" (click)="openDialog()">{{ 'form.info-rgpd' | translate }} </a>
                        <span [innerHTML]="'form.and-accept-privacy-policy' | translate"></span>
                    </span>
                    <span class="d-block text-error" *ngIf="!client.acceptLegal">
                        {{ 'form.validation.accept-legal' | translate }}
                    </span>
                </mat-checkbox>
            </div>
            <div class="col-12 mb-2 mb-sm-3">
                <mat-checkbox name="pmpMarketing" [disabled]="client.disabled" [(ngModel)]="client.acceptMarketing">
                    <strong [innerHTML]="'form.accept-marketing' | translate"></strong>:
                    <span [innerHTML]="'form.accept-marketing-text' | translate"></span>
                </mat-checkbox>
            </div>
        </div>

        <div class="row" *ngIf="(client.phoneExonerate || client.emailExonerate) && !client.disabled">
            <div class="col-12">
                <p class="mat-caption text-error font-italic">
                    {{ 'form.validation.exonerate' | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="bg-gray-gradient mt-4 pt-4 pb-3">
        <div class="container">
            <div class="row flex-nowrap justify-content-between align-items-end">
                <div class="col-auto flex-shrink-1" [ngSwitch]="client.type">
                    <h2 class="mat-subheading-1 text-blue font-weight-bold mb-2" *ngSwitchCase="ClientType.DISABLED">
                        {{ 'form.representative-data' | translate }}
                    </h2>
                    <h3 class="text-blue mat-display-1 font-weight-bold mb-0" *ngSwitchCase="ClientType.DISABLED">
                        {{ 'form.representative' | translate }}
                    </h3>
                    <h2 class="mat-subheading-1 text-blue font-weight-bold mb-2" *ngSwitchDefault>
                        {{ 'form.tutor-data' | translate }}
                    </h2>
                    <h3 class="text-blue mat-display-1 font-weight-bold mb-0" *ngSwitchDefault>
                        {{ 'form.tutor' | translate }}
                    </h3>
                </div>
                <div class="col-auto" [ngSwitch]="client.type">
                    <i class="text-blue" *ngSwitchCase="ClientType.DISABLED"></i>
                    <i class="icon-minor-natural text-blue" *ngSwitchDefault></i>
                </div>
            </div>
            <hr class="mt-1 mb-3" />
        </div>

        <ng-container *ngIf="!isAddingTutor">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="d-block" [ngSwitch]="client.type">
                            <ng-container *ngSwitchCase="ClientType.DISABLED">{{ 'form.select-representative' | translate }}</ng-container>
                            <ng-container *ngSwitchDefault>{{ 'form.select-tutor' | translate }}</ng-container>
                        </label>
                        <table class="table participants">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>
                                        {{ 'form.participants' | translate }}
                                    </th>
                                    <th>
                                        {{ 'form.name-and-surname' | translate }}
                                    </th>
                                    <th class="d-none d-md-table-cell">
                                        {{ 'form.document' | translate }}
                                    </th>
                                    <th class="d-none d-md-table-cell">
                                        {{ 'form.phone' | translate }}
                                    </th>
                                    <th class="d-none d-md-table-cell">
                                        {{ 'form.condition' | translate }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-template ngFor let-tutor [ngForOf]="tutors" let-i="index">
                                    <tr>
                                        <td>
                                            <i class="icon-natural-plus"></i>
                                        </td>
                                        <td [ngSwitch]="tutor.relation">
                                            <strong class="text-uppercase text-blue" *ngSwitchCase="ClientRelation.AUTHORIZED">{{
                                                'form.authorized' | translate
                                            }}</strong>
                                            <strong class="text-uppercase text-blue" *ngSwitchDefault>
                                                <ng-container *ngIf="tutor.isSoleHolder">{{ 'form.holder' | translate }}</ng-container>
                                                <ng-container *ngIf="!tutor.isSoleHolder">{{ 'form.co-holder' | translate }}</ng-container>
                                            </strong>
                                        </td>
                                        <td>
                                            <strong>{{ tutor.name }}</strong
                                            >&nbsp;<strong>{{ tutor.surname }}</strong>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>{{ tutor.docId }}</strong>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>{{ tutor.phone }}</strong>
                                        </td>
                                        <td class="d-none d-md-table-cell" [ngSwitch]="client.type">
                                            <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.DISABLED">{{
                                                'form.representative' | translate
                                            }}</strong>
                                            <strong class="text-uppercase text-blue" *ngSwitchCase="ClientType.MINOR">{{
                                                'form.tutor' | translate
                                            }}</strong>
                                            <strong class="text-uppercase text-blue" *ngSwitchDefault>-</strong>
                                        </td>
                                        <td class="text-right">
                                            <mat-checkbox [name]="'pmpTutor' + i" [(ngModel)]="selectedTutors[tutor.id]" (ngModelChange)="onTutorChecked(tutor, $event)"></mat-checkbox>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="d-none">
                    <input name="pmpHasTutor" type="checkbox" [ngModel]="isTutorChecked" required />
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isAddingTutor">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-between">
                            <div class="col-auto">
                                <label class="d-block">{{ 'form.ownership-relationship' | translate }}</label>
                                <mat-radio-group name="pmpPosition" [(ngModel)]="currentTutor.legalGuardianRelation" [required]="true">
                                    <mat-radio-button name="pmpCoOwner" color="blue-gray" [value]="ClientRelation.HOLDER">
                                        {{ 'form.co-holder' | translate }}
                                    </mat-radio-button>
                                    <mat-radio-button name="pmpAuthorized" color="blue-gray" [value]="ClientRelation.AUTHORIZED">
                                        {{ 'form.authorized' | translate }}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <hr class="gray mt-1 mb-4" />
                    </div>
                </div>
            </div>

            <thr-contract-form-participant-natural-person [client]="currentTutor" [pupil]="client"></thr-contract-form-participant-natural-person>
        </ng-container>
    </div>

</ng-container>